import { Check } from '@phosphor-icons/react';
import { useT } from '../../i18n';
import { cn } from '../../lib/cn';
import { stepStates, type StepId, type StepState } from '../../lib/layout';

const DOT: Record<StepState, string> = {
  done: 'bg-ink text-ink-on',
  current: 'bg-accent text-accent-on',
  todo: 'bg-surface-2 text-hint',
};

/** Мысль → Идея → Формат и текст → Озвучка (a carousel stops at «Формат и текст»). Not interactive. */
export function StepBar({ current, carousel = false }: { current: StepId; carousel?: boolean }) {
  const t = useT();
  const steps = stepStates(current, { carousel });
  return (
    <ol
      className={cn('grid px-4 pt-3 pb-4 max-w-lg mx-auto', steps.length === 3 ? 'grid-cols-3' : 'grid-cols-4')}
      aria-label={t.steps.label}
    >
      {steps.map((s, i) => {
        const next = steps[i + 1];
        return (
          <li
            key={s.id}
            aria-current={s.state === 'current' ? 'step' : undefined}
            className="flex flex-col items-center gap-1.5"
          >
            <span className="relative flex w-full justify-center">
              {i > 0 && (
                <span
                  aria-hidden
                  className={cn('absolute left-0 right-1/2 top-1/2 -translate-y-1/2 h-0.5', s.state === 'todo' ? 'bg-line' : 'bg-ink')}
                />
              )}
              {next && (
                <span
                  aria-hidden
                  className={cn('absolute left-1/2 right-0 top-1/2 -translate-y-1/2 h-0.5', next.state === 'todo' ? 'bg-line' : 'bg-ink')}
                />
              )}
              <span
                className={cn(
                  'relative z-10 inline-flex items-center justify-center w-[18px] h-[18px] rounded-full text-[10px] font-bold',
                  DOT[s.state],
                )}
              >
                {s.state === 'done' ? <Check size={11} weight="bold" /> : i + 1}
              </span>
            </span>
            <span className={cn('text-[11px] leading-[14px]', s.state === 'todo' ? 'text-hint' : 'text-fg', s.state === 'current' && 'font-semibold')}>
              {t.steps[s.id]}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
